import { render, staticRenderFns } from "./CreateTargetGroup.vue?vue&type=template&id=0aadfcc8&"
import script from "./CreateTargetGroup.vue?vue&type=script&lang=js&"
export * from "./CreateTargetGroup.vue?vue&type=script&lang=js&"
import style0 from "./CreateTargetGroup.vue?vue&type=style&index=0&id=0aadfcc8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports